<form nz-row novalidate
      #formAddress="ngForm"
      class="card-container-shadow"
      [ngClass]="{'card-container-shadow': !removeClassCardContainerShadow}"
>
  <div nz-col nzSpan="24">

    <!--Header-->
    <div nz-row *ngIf="showHeader">
      <div nz-col class="mb-md text-subtitle-bold-upper">
        <p>Dirección</p>
      </div>
    </div>
    <!-- /Header -->

    <!--Content-->
    <div class="address-container mb-sm">
      <div>
        <div [class]="cssLabelClass">País</div>
        <nz-select nzShowSearch nzAllowClear nzPlaceHolder="País"  [nzDisabled]="disabled" [required]="this.required" [(ngModel)]="address.country" #ngCountry="ngModel" name="country">
          <nz-option *ngFor="let country of countries;" [nzLabel]="country.name" [nzValue]="country.name"></nz-option>
        </nz-select>
        <app-message-field [field]="ngCountry"></app-message-field>
      </div>
      <div>
        <div [class]="cssLabelClass">Estado</div>
        <ng-container *ngIf="ngCountry.value !== 'México'; else isMX">
          <input nz-input [required]="this.required" [(ngModel)]="address.state" #ngState="ngModel" name="state" placeHolder="Estado">
          <app-message-field [field]="ngState"></app-message-field>
        </ng-container>
        <ng-template #isMX>
          <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Estado" [nzDisabled]="disabled" [required]="this.required" [(ngModel)]="address.state" #ngState="ngModel" name="state">
            <nz-option *ngFor="let state of mexicoStates;" [nzLabel]="state.name" [nzValue]="state.name"></nz-option>
          </nz-select>
          <app-message-field [field]="ngState"></app-message-field>
        </ng-template>
      </div>
      <div>
        <div [class]="cssLabelClass">Ciudad</div>
        <input nz-input  [required]="this.required" [disabled]="disabled" [(ngModel)]="address.city" #ngCity="ngModel" name="city" placeHolder="Ciudad">
        <app-message-field [field]="ngCity"></app-message-field>
      </div>
      <div>
        <div [class]="cssLabelClass">Colonia</div>
        <input nz-input [required]="this.required" [disabled]="disabled" [(ngModel)]="address.suburb" #ngSuburb="ngModel" name="suburb" placeholder="Colonia">
        <app-message-field [field]="ngSuburb"></app-message-field>
      </div>
      <div>
        <div [class]="cssLabelClass">Calle con número</div>
        <input nz-input [required]="this.required" [disabled]="disabled" [(ngModel)]="address.street" #ngStreet="ngModel" name="street" placeHolder="Calle con número">
        <app-message-field [field]="ngStreet"></app-message-field>
      </div>
      <div>
        <div [class]="cssLabelClass">Código postal</div>
        <input #cpField nz-input type="text" [disabled]="disabled" [required]="this.required" [(ngModel)]="address.cp" #ngCp="ngModel" name="cp" placeholder="Código postal" (ngModelChange)="helperValidationField.onValidateCP(address, ngCp)">
        <app-message-field [field]="ngCp"></app-message-field>
      </div>
    </div>
    <div class="mb-sm">
      <div> <!-- nzXs="24" -->
        <div [class]="cssLabelClass">Referencias</div>
        <textarea nz-input [disabled]="disabled" [nzAutosize]="{ minRows: this.rowsReference, maxRows: this.rowsReference }" [(ngModel)]="address.reference" #ngName="ngModel" name="reference" placeholder="Referencias"></textarea>
      </div>
    </div>
    <!-- / Content-->
  </div>
</form>
